// extracted by extract-css-chunks-webpack-plugin
module.exports = {"button_panel":"gop-role-create__button_panel--iRwl9","buttonPanel":"gop-role-create__button_panel--iRwl9"};